import React from 'react';
import { useTranslation } from 'react-i18next';
import { QRCode } from 'react-qr-code';

export default function WallQrPanel({ joinUrl }) {
    const { t } = useTranslation();

    return (
        <div className="absolute bottom-5 left-5 z-30 pointer-events-auto">
            {/* Margin instead of flex gap: the Cast/TV build targets Chrome 76,
                which doesn't support gap in flexbox (Chrome 84+). */}
            <div className="bg-white rounded-2xl p-3 flex flex-col items-center">
                <div className="bg-white p-2 rounded-lg">
                    <QRCode value={joinUrl} size={96} />
                </div>
                <span className="mt-2 text-gray-700 text-xs font-medium text-center leading-tight">
                    {t('Scan to add your photo!')}
                </span>
            </div>
        </div>
    );
}
